import "./doc-page.scss";


document.addEventListener('DOMContentLoaded', () => {
    initHandler();
    iniEventsSections(); 
});



const initHandler = () => {
    const current = document.querySelector('.doc-page__menu-link._current');

    if (current) {
        const section = current.closest('.doc-page__menu-section');

        if (section) {
            section.classList.add('_show');
        }
    }
}

const iniEventsSections = () => {
    const sections = Array.from(document.querySelectorAll('.doc-page__menu-section'));

    sections.forEach(item => {
        const nameElement = item.querySelector('.doc-page__menu-section-name');
    
        if (nameElement) {
            nameElement.addEventListener('click', event => {
                onClickSection(item, nameElement);
            });
        }
    });
}


const onClickSection = (sectionElement, nameElement) => {
    sectionElement.classList.toggle('_show');
};